import { DSCardWrapper } from "@components/design-system/molecules";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import ChooseTemplateConstruction from "../ChooseTemplateConstruction";
import TemplateExamplesChipMenu from "../ExamplesChipMenu";
import FileUploader from "../FileUploader";
import PreferencesSection from "../PreferencesSection";
import TemplateFields from "../TemplateFields";

const FormBuilderSection = ({
  control,
  setShowResetTemplateConstructionModal,
  openConfirmationOpenIfFieldsFilled,
  setShowConfirmTemplateConstructionModal,
  templateConstructionChoice,
  setTemplateConstructionChoice,
  handleHighlightClick,
  onFileUpload,
  highlightFileUploader,
  loadingExtraction,
}) => {
  return (
    <div className="flex flex-col space-y-8">
      <DSCardWrapper
        variant="default"
        padding="p-md"
        dataTestId="template-structure-section"
      >
        <div id="template-structure">
          {templateConstructionChoice === "scratch" && (
            <div className="mb-md">
              <TemplateExamplesChipMenu />
            </div>
          )}
          <ChooseTemplateConstruction
            setShowResetTemplateConstructionModal={
              setShowResetTemplateConstructionModal
            }
            openConfirmationOpenIfFieldsFilled={
              openConfirmationOpenIfFieldsFilled
            }
            setShowConfirmTemplateConstructionModal={
              setShowConfirmTemplateConstructionModal
            }
            selectedChoice={templateConstructionChoice}
            onSelect={setTemplateConstructionChoice}
            handleHighlightClick={handleHighlightClick}
          />

          {templateConstructionChoice === "upload" &&
            loadingExtraction && (
              <div
                className="text-center my-md flex flex-col items-center gap-sm border-2 border-dashed rounded-large p-md border-brand"
                data-testid="extracting-text-spinner"
              >
                <span>Extracting the text from your PDF...</span>
                <FontAwesomeIcon
                  icon={faSpinner}
                  size="2x"
                  className="animate-spin text-brand"
                />
              </div>
            )}
          {templateConstructionChoice === "upload" &&
            !loadingExtraction && (
              <FileUploader
                onFileUpload={onFileUpload}
                highlightFileUploader={highlightFileUploader}
              />
            )}

          {(templateConstructionChoice === "scratch" ||
            templateConstructionChoice === "upload") && (
            <TemplateFields control={control} />
          )}
        </div>
      </DSCardWrapper>

      <DSCardWrapper
        variant="default"
        padding="p-md"
        dataTestId="template-preferences-section"
      >
        <div id="template-preferences">
          <PreferencesSection control={control} />
        </div>
      </DSCardWrapper>
    </div>
  );
};

export default FormBuilderSection;
